import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { hasSubaccounts as hasSubaccountsSelector } from 'src/selectors/subaccounts';
import { isSubaccountUser as isSubaccountUserSelector } from 'src/helpers/conditions/user';
import { AUTOMATIC_SEEDING_ROUTE } from '../../constants';
import { PRIMARY_SUBACCOUNT } from 'src/constants';

export function AutomaticSeedingRouteHandler() {
  const hasSubaccounts = useSelector(hasSubaccountsSelector);
  const isSubaccountUser = useSelector(isSubaccountUserSelector);

  if (hasSubaccounts) {
    return <Redirect to={`${AUTOMATIC_SEEDING_ROUTE}/config/list`} />;
  }

  if (isSubaccountUser) {
    return <Redirect to={`${AUTOMATIC_SEEDING_ROUTE}/config`} />;
  }

  return <Redirect to={`${AUTOMATIC_SEEDING_ROUTE}/config/${PRIMARY_SUBACCOUNT.id}`} />;
}
